import { render, staticRenderFns } from "./book-selector-dialog.component.vue?vue&type=template&id=563b21ec&scoped=true"
import script from "./book-selector-dialog.component.vue?vue&type=script&lang=ts"
export * from "./book-selector-dialog.component.vue?vue&type=script&lang=ts"
import style0 from "./book-selector-dialog.component.vue?vue&type=style&index=0&id=563b21ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b21ec",
  null
  
)

export default component.exports